var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigFreeze(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 9.5,
    x2: 26,
    y2: 9.5,
    stroke: "#99F9FF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 10.5,
    x2: 26,
    y2: 10.5,
    stroke: "#99F9FF"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 11.5,
    x2: 26,
    y2: 11.5,
    stroke: "#99F9FF"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 7.5,
    x2: 13,
    y2: 7.5,
    stroke: "#99F9FF"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 6.5,
    x2: 13,
    y2: 6.5,
    stroke: "#99F9FF"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 8.5,
    x2: 13,
    y2: 8.5,
    stroke: "#99F9FF"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 7.5,
    x2: 16,
    y2: 7.5,
    stroke: "#99F9FF"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 6.5,
    x2: 16,
    y2: 6.5,
    stroke: "#99F9FF"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 8.5,
    x2: 16,
    y2: 8.5,
    stroke: "#99F9FF"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4.5,
    x2: 19,
    y2: 4.5,
    stroke: "#99F9FF"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3.5,
    x2: 19,
    y2: 3.5,
    stroke: "#99F9FF"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 5.5,
    x2: 19,
    y2: 5.5,
    stroke: "#99F9FF"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 1.5,
    x2: 22,
    y2: 1.5,
    stroke: "#99F9FF"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 0.5,
    x2: 22,
    y2: 0.5,
    stroke: "#99F9FF"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 2.5,
    x2: 22,
    y2: 2.5,
    stroke: "#99F9FF"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 19.5,
    x2: 7,
    y2: 19.5,
    stroke: "#99F9FF"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18.5,
    x2: 7,
    y2: 18.5,
    stroke: "#99F9FF"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20.5,
    x2: 7,
    y2: 20.5,
    stroke: "#99F9FF"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 16.5,
    x2: 10,
    y2: 16.5,
    stroke: "#99F9FF"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 15.5,
    x2: 10,
    y2: 15.5,
    stroke: "#99F9FF"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 17.5,
    x2: 10,
    y2: 17.5,
    stroke: "#99F9FF"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 13.5,
    x2: 13,
    y2: 13.5,
    stroke: "#99F9FF"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12.5,
    x2: 13,
    y2: 12.5,
    stroke: "#99F9FF"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14.5,
    x2: 13,
    y2: 14.5,
    stroke: "#99F9FF"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 4.5,
    x2: 10,
    y2: 4.5,
    stroke: "#99F9FF"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 3.5,
    x2: 10,
    y2: 3.5,
    stroke: "#99F9FF"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5.5,
    x2: 10,
    y2: 5.5,
    stroke: "#99F9FF"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 1.5,
    x2: 7,
    y2: 1.5,
    stroke: "#99F9FF"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 0.5,
    x2: 7,
    y2: 0.5,
    stroke: "#99F9FF"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 2.5,
    x2: 7,
    y2: 2.5,
    stroke: "#99F9FF"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 19.5,
    x2: 22,
    y2: 19.5,
    stroke: "#99F9FF"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 18.5,
    x2: 22,
    y2: 18.5,
    stroke: "#99F9FF"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 20.5,
    x2: 22,
    y2: 20.5,
    stroke: "#99F9FF"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16.5,
    x2: 19,
    y2: 16.5,
    stroke: "#99F9FF"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 15.5,
    x2: 19,
    y2: 15.5,
    stroke: "#99F9FF"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 17.5,
    x2: 19,
    y2: 17.5,
    stroke: "#99F9FF"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 13.5,
    x2: 16,
    y2: 13.5,
    stroke: "#99F9FF"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 12.5,
    x2: 16,
    y2: 12.5,
    stroke: "#99F9FF"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 14.5,
    x2: 16,
    y2: 14.5,
    stroke: "#99F9FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigFreeze);
export default __webpack_public_path__ + "static/media/bigFreeze.3c30aebdcb55b3e95c966585697a0555.svg";
export { ForwardRef as ReactComponent };